export default __webpack_public_path__ + "static/media/circle-arrow.90e36b43.svg";